<template>
    <div class="box">
        <p>您还未绑定店铺</p>
        <ManualHelp />
    </div>
</template>
<script>
import ManualHelp from '@/components/ManualHelp';
export default {
    components:{
        ManualHelp,
    },
    name:'NoBuildShop',
}

</script>
<style lang="scss" scoped>
    @import './index.scss'
</style>